/**
 * This contains recurring values/constants used by API logic
 *
 * NOTE: If there are newly added values (constants or environment variables) that
 * are recurring across the API logic, they should be ideally added here
 */
const API_PATH = import.meta.env.VITE_API_PATH ?? '';

export const AUTH_LOGIN = {
  USER_PASS: `${import.meta.env.VITE_HTTPS_PROTOCOL}${API_PATH}/login`,
  REF_KEY: `${
    import.meta.env.VITE_HTTPS_PROTOCOL
  }${API_PATH}/login/reference-key`,
  REFRESH_KEY: `${
    import.meta.env.VITE_HTTPS_PROTOCOL
  }${API_PATH}/token/refresh`,
};

export const AUTH_REGISTER = `${
  import.meta.env.VITE_HTTPS_PROTOCOL
}${API_PATH}/register`;

export const CLOSE_REPORT = `${
  import.meta.env.VITE_HTTPS_PROTOCOL
}${API_PATH}/close-report`;

export const SUBMIT_REPORT_AUTHENTICATED = '/submit-report-authenticated';

export const ADDITIONAL_INFORMATION = '/additional-information';

export const CUSTOMER_ADDITIONAL_INFORMATION =
  '/customer-additional-information';

export const REPORT_DRAFTS = '/reports/draft';

export const REPORT_TYPES = '/report-types';
